import React from 'react';
import axios from "../../../../containers/api";
import { Alert, Button, FormGroup, Input, Label, CustomInput } from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
class EditTransportationCompany extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            OneTransportationCompany: this.props && this.props.OneTransportationCompany,
            errors: [],
            Province: null,
            CityList: [],
            City: null,
            AnnouncementLimitMinutes: 0,
            ProvinceList:  [],
            isModal: this.props && this.props.isModal,
        }
    }
    componentWillMount() {
        this.loadProvinces();
        
    }
    componentDidMount() {
        console.log(this.props.OneTransportationCompany);
        //if (!this.state.isModal) {
        //    // this.CheckMemberTypeIsAdmin();
        //    this.loadProvinces();
        //}
      
    }
    //componentWillReceiveProps(nextProps) {
    //    if (this.props !== nextProps) {
    //        this.setState({ ProvinceList: this.props.ProvinceList });
    //    }
    //}
    Replacedata = () => {
        this.state.ProvinceList && this.state.ProvinceList.map((v) => {
            if (v.provinceId === this.state.OneTransportationCompany.provinceId) {
                this.setState({
                    Province: v,
                   
                }, () => this.loadCities(this.state.OneTransportationCompany.provinceId,this.state.OneTransportationCompany.cityId));
            }
        });
        

    }
    loadProvinces = () => {
        this.props.showSpinner();
        axios.get('api/v1/provinces/GetAll')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ ProvinceList: res.data.data },()=> this.Replacedata());
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    loadCities = (id, cityId) => {
        this.props.showSpinner();
        axios.get('api/v1/cities/GetCityByProvinceId/' + id)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ CityList: res.data.data });
                if (cityId !== null && cityId !== undefined) {
                     res.data.data && res.data.data.map((v) => {
                         if (v.cityId === cityId) {
                            this.setState({
                                City: v
                            });
                        }
                    });
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.OneTransportationCompany.transportationCompanyName.length ===0) {
            error.push("وارد كردن نام شركت حمل و نقل الزامی میباشد");
        }
        if (this.state.OneTransportationCompany.nationalId.length < 10 ) {
            error.push("کد ملی نباید کمتر از ۱۰ حرف باشد.");
        }
        if (this.state.OneTransportationCompany.tell.length === 0 && this.state.OneTransportationCompany.mobile.length === 0) {
            error.push("وارد كردن تلفن يا موبايل شركت حمل و نقل الزامی میباشد.");
        }
        if (this.state.OneTransportationCompany.address.length ===0) {
            error.push("وارد كردن آدرس شركت حمل و نقل الزامی میباشد.");
        }
        if (this.state.City === null || this.state.City === undefined) {
            error.push("انتخاب شهر الزامی میباشد.");
        }
        this.setState({errors: error});
        if (error.length === 0) {
            this.EditTransportationCompany();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    EditTransportationCompany = () => {
        this.props.showSpinner();
        const addModel = {
            Id: toEnglishNumbers(this.state.OneTransportationCompany.transportationCompanyId),
            TransportationCompanyName: toEnglishNumbers(this.state.OneTransportationCompany.transportationCompanyName),
            Email: toEnglishNumbers(this.state.OneTransportationCompany.email),
            NationalId: toEnglishNumbers(this.state.OneTransportationCompany.nationalId),
            Address: toEnglishNumbers(this.state.OneTransportationCompany.address),
            PostalCode: toEnglishNumbers(this.state.OneTransportationCompany.postalCode),
            Tell: toEnglishNumbers(this.state.OneTransportationCompany.tell),
            AnnouncementLimitMinutes: toEnglishNumbers(this.state.OneTransportationCompany.announcementLimitMinutes),
            Mobile: toEnglishNumbers(this.state.OneTransportationCompany.mobile),
            IsBillAndDraft: this.state.OneTransportationCompany.isBillAndDraft,
            CityId: this.state.City !== null ? this.state.City.cityId : null
        };

        axios.post('/api/v1/transportation-companies/EditTransportationCompany', addModel)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    
                    this.props.showAlert(res.data.message, "success");
                    this.props.closeModal("EditModal");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
   
    selectHandleChange = (event, value, name) => {
        this.setState({ [name]: value },
            () => {
                if (name === "Province") {
                    if (value !== undefined && value !== null) {
                        this.setState({
                            City: null
                        }, () => this.loadCities(value.provinceId));
                    }
                    else {
                        this.setState({
                            City: null, CityList: []
                        })
                    }
                }

            });
    };
    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>نام کامل شرکت حمل و نقل</Label>
                        <Input value={this.state.OneTransportationCompany.transportationCompanyName} maxLength={300}
                            onChange={(e) => this.setState({ OneTransportationCompany: { ...this.state.OneTransportationCompany, transportationCompanyName: toEnglishNumbers(e.target.value)} })}/>
                    </FormGroup>
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>موبایل</Label>
                        <Input value={this.state.OneTransportationCompany.mobile} maxLength={11}
                            onChange={(e) => this.setState({ OneTransportationCompany: { ...this.state.OneTransportationCompany, mobile: toEnglishNumbers(e.target.value) } })} />
                    </FormGroup>
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.OneTransportationCompany.nationalId} maxLength={11}
                            onChange={(e) => this.setState({ OneTransportationCompany: { ...this.state.OneTransportationCompany, nationalId: toEnglishNumbers(e.target.value)} })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>آدرس</Label>
                        <Input value={this.state.OneTransportationCompany.address}
                               onChange={(e) => this.setState({ OneTransportationCompany: {...this.state.OneTransportationCompany, address: toEnglishNumbers(e.target.value)} })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>کد پستی</Label>
                        <Input value={this.state.OneTransportationCompany.postalCode} maxLength={10}
                               onChange={(e) => this.setState({ OneTransportationCompany: {...this.state.OneTransportationCompany, postalCode: toEnglishNumbers(e.target.value)} })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>تلفن</Label>
                        <Input value={this.state.OneTransportationCompany.tell} maxLength={100}
                               onChange={(e) => this.setState({ OneTransportationCompany: {...this.state.OneTransportationCompany, tell: toEnglishNumbers(e.target.value)} })}/>
                    </FormGroup>
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>ایمیل</Label>
                        <Input value={this.state.OneTransportationCompany.email} maxLength={100}
                            onChange={(e) => this.setState({ OneTransportationCompany: { ...this.state.OneTransportationCompany, email: toEnglishNumbers(e.target.value)} })}/>
                    </FormGroup>
                   
                   
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>استان</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="Province"
                            options={this.state.ProvinceList}
                            getOptionLabel={(option) => option.provinceName}
                            value={this.state.Province}
                            onChange={(e, v) => this.selectHandleChange(e, v, "Province")}
                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                        />
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>شهر</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="City"
                            options={this.state.CityList}
                            getOptionLabel={(option) => option.cityName}
                            value={this.state.City}
                            onChange={(e, v) => this.selectHandleChange(e, v, "City")}
                            renderInput={(params) => (<TextField{...params} variant="standard" />)}
                        />
                    </FormGroup>
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>زمان محدودیت اعلام بار</Label>

                        <Input
                            value={this.state.OneTransportationCompany.announcementLimitMinutes}
                            maxLength={3}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[^0-9۰-۹]/g, ""); // فقط عدد

                                // حذف صفرهای اضافی اول عدد
                                if (value.length > 1) {
                                    value = value.replace(/^0+/, "");
                                }

                                // اگر خالی شد → صفر بشه
                                if (value === "") value = "0";

                                this.setState({
                                    OneTransportationCompany: {
                                        ...this.state.OneTransportationCompany,
                                        announcementLimitMinutes: value
                                    }
                                });
                            }}
                        />

                    </FormGroup>
                    <FormGroup className="w-md-30 w-100 px-1"> 
                        <CustomInput
                            checked={this.state.OneTransportationCompany.isBillAndDraft}
                            onChange={(e) =>
                                this.setState({
                                    OneTransportationCompany: {
                                        ...this.state.OneTransportationCompany,
                                        isBillAndDraft: e.target.checked
                                    }
                                })
                            }
                            type="checkbox"
                            id="IsBillAndDraft"
                            label="دسترسی حواله یا بارنامه"
                        />

                    </FormGroup>
                    <FormGroup className="w-md-30 w-100 px-1">
                    </FormGroup>
                </div>

                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.props.showSweetAlert("آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "", "warning", this.validateInputData)}>
                            ثبت
                        </Button>
                    </FormGroup>
                </div>
            </div>
        );
    }
}

export default EditTransportationCompany;